import { render } from "./ListDocument.vue?vue&type=template&id=9b48ef4e"
import script from "./ListDocument.vue?vue&type=script&lang=ts"
export * from "./ListDocument.vue?vue&type=script&lang=ts"
script.render = render

export default script